export const AUTH_CONFIG = {
  accessTokenKey: 'pn_access_token',
  refreshTokenKey: 'pn_refresh_token',
  userKey: 'pn_user',
  sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours
};
